import React from "react";
import { Route } from "react-router-dom";

import { useUserState } from "../../context/UserContext";
import AccessDenied from "../../pages/error/AccessDenied";
import { hasAppointmentSettingsAccess } from "../../utils/appointmentSettingsAuthorization";

export default function AdminRoute({ component: Component, ...rest }) {
  const { user } = useUserState();

  return (
    <Route
      {...rest}
      render={routeProps =>
        hasAppointmentSettingsAccess(user) ? (
          <Component {...routeProps} />
        ) : (
          <AccessDenied />
        )
      }
    />
  );
}
